'use strict';

module.exports = {
    SIGN: 'ลงชื่อ',
    SIGN_JOIN: 'ลงชื่อเข้าใจหรือสมัครฟรี!',
    EMAIL_EXISTS: 'มีการใช้งานอีเมลนี้แล้ว',
    INVALID_EMAIL: 'กรุณากรอกที่อยู่อีเมลที่ใช้งานได้จริง',
    INVALID_FIRST_NAME: 'กรุณากรอกชื่อจริง',
    INVALID_LAST_NAME: 'กรุณากรอกนามสกุลจริง',
    INVALID_PASSWORD: 'กรุณากรอกตัวอักษร 6-20 อักษร (A-Z, a-z, 0-9 เท่านั้น)',
    INVALID_REPASSWORD: 'พาสเวิร์ดไม่ตรงกัน',
    INVALID_VALID_CODE: 'กรุณากรอกรหัสที่ถูกต้อง',
    UNAVIALABLE_SERVICE: 'ไม่สามารถให้บริการได้ในขณะนี้ กรุณาลองใหม่ในภายหลัง',
    EMPTY_VALID_CODE: 'พิมพ์ตัวอักษรที่เห็นในภาพ',
    NOT_MEMBER: 'ไม่ใช่สมาชิก?',
    ALREADY_MEMBER: 'เป็นสมาชิกของ AliExpress/Alibaba อยู่แล้ว?',
    EMAIL: 'ที่อยู่ของอีเมล',
    CONTACT_NAME: 'ชื่อติดต่อ:',
    FIRST_NAME: 'ชื่อ',
    LAST_NAME: 'นามสกุล',
    PASSWORD: 'พาสเวิร์ด',
    REPASSWORD: 'ใส่พาสเวิร์ดอีกครั้ง:',
    EMPTY_CODE: 'ใส่รหัสที่แสดง:',
    REFRESH: 'รีเฟรช',
    CREATE_MY_ACCOUNT: 'สร้างบัญชีผู้ใช้ของฉัน',
    NAME: 'ชื่อ',
    VERIFICATION: 'รหัสยืนยัน',
    AGREE_MENT: 'เมื่อสร้างบัญชีแล้ว หมายความว่าคุณยินยอมตาม',
    AE_MEMBER_SHIP: 'สมาชิก AliExpress.com ฟรี',
    AND: 'และน',
    PRIVACY_POLICY: 'โยบายความเป็นส่วนตัว',
    SLIDE_SUBMIT: 'เลื่อน ไปทางขวา เพื่อ ตรวจสอบ',
    SLIDE_SUBMIT_TIPS: 'ความสำเร็จ',
    LOADING: 'กำลังโหลด...',
    SLIDE_SUBMIT_ERROR_TIPS: 'เลื่อน ไปทางขวา เพื่อ ตรวจสอบ',
    SHOP_NOW: 'สั่งซื้อตอนนี้',
    SIGN_IN: 'ลงชื่อเข้าใช้',
    REGISTER_SMS: 'ลงทะเบียน SMS',
    REGISTER_EMAIL: 'ลงทะเบียนอีเมล',
    PHONE_NUMBER: 'หมายเลขโทรศัพท์',
    VALID_NUMBER: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้องเข้าไป',
    SEND_SMS_CODE: 'การส่งรหัส SMS',
    SMS_POLICY: 'เราจะส่งรหัสยืนยันทาง SMS ไปยังหมายเลขโทรศัพท์ที่คุณป้อน การตรวจสอบกันแน่ว่ารหัสประเทศและหมายเลขโทรศัพท์ถูกต้อง',
    SEND_TO: 'เราส่งรหัสไปยังที่ แล้ว',
    VERIFICATION_RECEIVED: 'การป้อนรหัสยืนยันที่คุณได้รับหรือ',
    EDIT_NUMBER: 'แก้ไขหมายเลข',
    RESEND_CODE: 'การส่งรหัสอีกครั้ง',
    LAST_STEP: 'ขั้นตอนสุดท้าย',
    SET_SIGN_IN_PASSWORD: 'กรุณาตั้งรหัสผ่านเข้าสู่ระบบมาให้บัญชีของคุณปลอดภัยยิ่งขึ้น',
    INVALID_PHONE_PASSWORD: '6-20 ตัวอักษร (ตัวอักษรและตัวเลขเท่านั้น)',
    NOT_CORRECT_CODE: 'รหัสนี้ไม่ถูกต้อง โปรดลองใหม่อีกครั้ง',
    SAVE_PASSWORD: 'การบันทึกรหัสผ่าน',
    NO_RECEIVED_CODE: 'หากคุณยังไม่ได้รับรหัส สามารถลองทำ',
    VIA_EMAIL: 'ลงทะเบียนผ่านทางอีเมล์'
};